"use es6";

import { createContext } from 'react';

/**
 * Internal, exported only for usage in Framer
 */
const SwitchLayoutGroupContext = /*#__PURE__*/createContext({});
export { SwitchLayoutGroupContext };